import { useCallback, useId } from 'react';
import styled from 'styled-components';

import { MEDIA_QUERIES } from '#/hooks/useResponsiveValue';
import { modalActions, useModalStore } from '#/store/modal/modal.store';
import { tb } from '#/store/translation/translation.store';

import { Button } from '../Button/Button';
import { Modal } from './Modal';

const Description = styled.p`
  margin: 0;
  padding: 0;
`;

const Actions = styled.div`
  margin-top: 1rem;
`;

const StyledModal = styled(Modal)`
  padding-top: 2.5rem;
  min-width: 20rem;
  max-width: 40rem;

  @media (${MEDIA_QUERIES.xs}) {
    min-width: initial;
  }
`;

/** Component responsible for showing validation error messages. It works in pair with `useModal` hook */
export const GenericModal = () => {
  const {
    isModalVisible,
    opts: { message, buttonLabel = tb('button.ok'), title, onDismiss, onOk },
  } = useModalStore();

  const titleId = useId();
  const descriptionId = useId();

  const closeModal = useCallback(() => {
    modalActions.hideModal();
    onDismiss?.();
  }, [onDismiss]);

  return (
    <StyledModal
      aria-describedby={descriptionId}
      aria-labelledby={titleId}
      closeOnEsc
      closeOnOverlayClick
      isOpen={isModalVisible}
      onClose={closeModal}
      role="alertdialog"
      showCloseButton
    >
      {title && <h2 id={titleId}>{title}</h2>}
      <Description id={title ? descriptionId : titleId}>{message}</Description>
      <Actions>
        <Button onClick={onOk || closeModal}>{buttonLabel}</Button>
      </Actions>
    </StyledModal>
  );
};
